import { Grid } from '@mui/material';
import { ApexOptions } from 'apexcharts';
import { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import { getTimeToServiceAnalytics } from 'wisestep-api';
import { WsTypography } from 'wisestep-base';

import { ISeriesDataType } from '../../types';

import IPayloadDTOJobsCrm from './types/IPayloadDTOJobsCrm';

const TimeToServiceJobsCRM = ({ payload }: IPayloadDTOJobsCrm) => {
  const [aggregatedData, setAggregatedData] = useState<
    Record<string, { from?: number; to?: number; doc_count: number }>
  >({});
  const [seriesData, setSeriesData] = useState<ISeriesDataType[]>([{ x: '', y: 0 }]);

  useEffect(() => {
    const fetchData = async () => {
      const response = await getTimeToServiceAnalytics(payload);
      setAggregatedData(response.data.aggregations.aggregation.buckets);
    };
    fetchData();
  }, [payload]);
  useEffect(() => {
    const generatedSeries = Object.values(aggregatedData).map((obj) => ({
      x: `${obj?.from} to ${obj?.to}`,
      y: obj.doc_count,
    }));

    setSeriesData(generatedSeries);
  }, [aggregatedData]);

  const options: ApexOptions = {
    chart: {
      type: 'bar',
    },
    yaxis: {
      title: { text: 'Submissions', style: { fontSize: '15px' } },
    },
    xaxis: {
      title: { text: 'Time To Service (Hours)', style: { fontSize: '15px' } },
    },
  };
  return (
    <Grid container justifyItems={'space-evenly'} spacing={2} textAlign="center">
      <Grid item xs={12}>
        <WsTypography># Time to Service</WsTypography>
        <ReactApexChart
          options={options}
          type="bar"
          series={[
            {
              data: seriesData,
            },
          ]}
          title="Time to Service"
          height={400}
        />
      </Grid>
    </Grid>
  );
};

export default TimeToServiceJobsCRM;
